import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import InfoPopover from 'Components/InfoPopover';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import DescriptionText from 'Routes/Updrs/utils/DescriptionText';
import { updrs_iii } from 'neuro-schemas';

const { calculateScore } = updrs_iii;

const UPDRSIII = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  documents = documents.filter(d => d.type !== 'levodopa' && d.type !== 'dbs');
  return (
    <HistorySection
      headerText={<FormattedMessage id={'updrs.updrsIII'} />}
      newButton={
        <DocumentCreationButton
          name="updrs_iii"
          text={'updrs.newUpdrsIII'}
          onClick={startEdit({}, 'updrs_iii')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'updrsIII'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={4}>
              <FormattedMessage id={'updrs.scoreMDS'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'updrs.scoreManual'} />
            </Item>
          </>
        }
        contentFormat={d => {
          const score = calculateScore(d);
          return (
            <>
              <Item xs={4}>
                {d.testType === 'MDSUPDRS' ? (score ?? <InfoPopover text="general.notFilled" color="primary" />) : '-'}
              </Item>
              <Item xs={4}>
                {d.testType === 'UPDRS' ? (score ?? <InfoPopover text="general.notFilled" color="primary" />) : ''}
              </Item>
            </>
          );
        }}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'updrs_iii'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default UPDRSIII;
